import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { OrderResponse } from '@/cowboy/order/object/OrderResponse'
import { OrderValidationRulesResponse } from '@/cowboy/order/object/OrderValidationRulesResponse'

export class OrderApi extends HttpInjector {
  // The grpc deadline used for the call that is timing out while placing the order is 60s.  Let's set our
  // timeout to something slightly lower, so that we can properly catch the timeout instead of just getting a 500 back
  static PLACE_ORDER_TIMEOUT_MS = 55000

  /**
   * Request to Printable redeem url
   * @param {string} cartExternalRefId
   * @return {Promise<OrderResponse>}
   */
  static async fetchOrderStatus (cartExternalRefId) {
    const response = await this.$http.get(
      `/order/${this.codeVersion.requestCode}/externalRefId/${cartExternalRefId}/status?urlVersion=${this.codeVersion.urlVersion}`
    )
    return this.cast(response.data, OrderResponse)
  }

  /**
   * Request get order validation Rules that include
   * all blacklisted email domains
   * @return {Promise<OrderValidationRulesResponse>}
   */
  static async fetchOrderValidationRules () {
    const response = await this.$http.get('/order/validation-rules')
    return this.cast(response.data, OrderValidationRulesResponse)
  }

  /**
   * Request to place an order
   * @param {string} externalReferenceId
   * @param {string} captchaToken
   * @param {LineItem} lineItems
   * @return {Promise<OrderResponse>}
   */
  static async placeOrder (externalReferenceId, captchaToken, lineItems) {
    const body = {
      sendEmail: true,
      lineItems
    }
    const config = {
      timeout: OrderApi.PLACE_ORDER_TIMEOUT_MS,
      params: {
        captchaToken,
        urlVersion: this.codeVersion.urlVersion
      }
    }
    const response = await this.$http.post(
      `/order/${this.codeVersion.requestCode}/externalRefId/${externalReferenceId}`,
      body,
      config)
    return this.cast(response.data, OrderResponse)
  }
}
